'use client';
import React, { useState } from 'react';
import dynamic from 'next/dynamic';

const NiftyChartInner = dynamic(() => import('./NiftyChartInner'), { ssr: false });

const ranges = [
  { id: 'range-1d', label: '1D' },
  { id: 'range-5d', label: '5D' },
  { id: 'range-1m', label: '1M' },
  { id: 'range-3m', label: '3M' },
];

export default function NiftyChartSection() {
  const [activeRange, setActiveRange] = useState('range-1d');

  return (
    <div className="card-surface p-5 h-full">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-base font-semibold">NIFTY 50 Intraday</h2>
          <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>
            15 May 2026 · NSE · Real-time simulation
          </p>
        </div>
        <div className="flex items-center gap-1">
          {ranges?.map((r) => (
            <button
              key={r?.id}
              onClick={() => setActiveRange(r?.id)}
              className={`px-2.5 py-1 text-xs rounded font-medium transition-all duration-150 ${
                activeRange === r?.id
                  ? 'text-primary-foreground'
                  : 'text-muted-foreground hover:bg-muted'
              }`}
              style={activeRange === r?.id ? { background: 'var(--primary)' } : {}}
            >
              {r?.label}
            </button>
          ))}
        </div>
      </div>
      <NiftyChartInner range={activeRange} />
    </div>
  );
}